/**
 * Shared react-select styles for all stock module dropdowns.
 * Mirrors the CN Good selector styling from StockPurchaseOrderModal.
 */

export const stockSelectStyles = (hasError = false) => ({
  control: (base, state) => ({
    ...base,
    borderRadius: '0.5rem',
    borderColor: hasError ? '#f87171' : '#e2e8f0',
    minHeight: '36px',
    height: '36px',
    fontSize: '0.875rem',
    backgroundColor: state.isDisabled ? '#f8fafc' : '#fff',
    boxShadow: state.isFocused ? '0 0 0 1px rgba(0,168,132,0.4)' : 'none',
    '&:hover': { borderColor: hasError ? '#f87171' : '#cbd5e1' },
  }),
  valueContainer: (base) => ({ ...base, padding: '0 10px' }),
  indicatorsContainer: (base) => ({ ...base, height: '36px' }),
  option: (base, state) => ({
    ...base,
    fontSize: '0.875rem',
    backgroundColor: state.isSelected ? '#BFEDE4' : state.isFocused ? '#f0fdf9' : undefined,
    color: '#1e293b',
  }),
  menu: (base) => ({ ...base, zIndex: 20000 }),
  menuPortal: (base) => ({ ...base, zIndex: 20000 }),
  singleValue: (base, state) => ({
    ...base,
    color: state.isDisabled ? '#94a3b8' : '#1e293b',
  }),
  placeholder: (base) => ({
    ...base,
    color: '#94a3b8',
    fontSize: '0.875rem',
  }),
});
